import React from "react";
import PaginationItem from "./PaginationItem";

interface PaginationProps extends React.HTMLAttributes<HTMLElement> {  
  resultsNumber?: number | undefined
  resultsPerPageSelect: Array<number>
  resultsPerPage: number
  pageRange?: Array<number> | undefined
  currentPage: number
  backwardDisabled?: string | undefined
  forwardDisabled?: string | undefined
  onChangeHandler?: React.ChangeEventHandler<HTMLSelectElement> | undefined
  pageChangeControl?: React.MouseEventHandler<HTMLButtonElement> | undefined
};

class Pagination extends React.Component<PaginationProps> {
  render() {
    if (!this.props.hidden)
    return (     
      <div className={this.props.className}>
        <div className={this.props.className + '-filter'}>
          <div className={this.props.className + '-filter-text'}>
            Mostrando
          </div>
          <div>
            <select
              onChange={this.props.onChangeHandler}
            >            
              {this.props.resultsPerPageSelect.map((val) => 
                <option key={'s' + val} value={val}>{val}</option>
              )} 
            </select>
          </div>
          <div className={this.props.className + '-filter-text'}>
            de {this.props.resultsNumber} resultados
          </div>
        </div>
        <div>
        <div
          style={{
            height:"48",
            display:"flex",
            alignItems:"flex-start",            
          }}
        >
          <PaginationItem
            className={this.props.className + '-arrow'}
            disabled={this.props.backwardDisabled}
            onClick={this.props.pageChangeControl}
            name="fly-first"
          >
            {"<<"}
          </PaginationItem>
          <PaginationItem
            disabled={this.props.backwardDisabled}
            onClick={this.props.pageChangeControl}
            name="step-backward"
          >
            {"<"}
          </PaginationItem>
          <React.Fragment key=".0">           
            {this.props.pageRange &&
              this.props.pageRange.map((val,index) =>
                <PaginationItem
                  className={this.props.className + '-page'}
                  key={index}                  
                  active={(val===this.props.currentPage) ? "true" : undefined}
                  onClick={this.props.pageChangeControl}
                  name={val.toString()}
                >
                  {val.toString()}
                </PaginationItem>
            )}
          </React.Fragment>
          <PaginationItem
            disabled={this.props.forwardDisabled}
            onClick={this.props.pageChangeControl}
            name="step-forward"
          >
            {">"}
          </PaginationItem>
          <PaginationItem
            disabled={this.props.forwardDisabled}
            onClick={this.props.pageChangeControl}
            name="fly-last"
          >
            {">>"}
          </PaginationItem>
        </div>
        </div>
      </div>     
    );
  }
}

export default Pagination;